<template>
  <div>
    <div class="flex flex-col md:hidden bgImageMobile w-screen h-screen">
      <div class="flex flex-col justify-center items-center"
      v-if="!authenticated && $route.fullPath !== '/signin'
          && $route.fullPath !== '/registration'">
        <router-link to="/signin" class="mr-2 text-lg px-6 py-2 bg-orange-academy-300 text-white
          rounded uppercase shadow-lg transform block md:hidden mt-56 w-auto
          duration-500 hover:scale-90 animate-translate-from-top
          hover:-translate-y-4"
          >
            {{ $t('header.login') }}
        </router-link>
        <span class="text-white my-4">OR</span>
        <router-link to="/registration">
          <button type="submit" class="mr-2 text-lg px-6 py-2 bg-orange-academy-300 text-white
          rounded uppercase shadow-lg transform block md:hidden
          duration-500 hover:scale-90 animate-translate-from-top
          hover:-translate-y-4 duration-400"
          >
          {{$t('register.register')}}
          </button>
        </router-link>
      </div>
      <h1 class="flex text-2xl w-full p-3 rounded items-center font-black
            text-bold justify-center text-center text-white
            animate-translate-from-top transform mt-32
          hover:-translate-y-4 duration-300">
              {{ title }}!
      </h1>
    </div>
    <div class=" flex-col sticky top-0 inset-y-0 text-center
      hidden md:flex">
      <div class="flex justify-center items-center w-full relative">
        <div class="relative">
          <img src="../images/Harp Ecademy.jpg" class="w-screen h-screen">
        </div>
        <h1 class="text-xl md:text-2xl w-full p-3 rounded mt-6 md:uppercase tracking-wider
            text-bold justify-center text-center text-white absolute">
              {{ title }}!
        </h1>
        <!-- <div class="flex items-center">
          <img class="animate-translate-from-left transform
          hover:-translate-y-4 duration-500 w-52 h-72 mx-2" src="../images/violin.jpg">
        </div>
        <div class="flex flex-col">
          <img class="animate-translate-from-top transform
          hover:-translate-y-4 duration-500 w-72 h-72 mx-4" src="../images/drum.jpg">
          <img class="animate-translate-from-left w-56 h-72 transform
            hover:-translate-y-4 duration-500 z-20 mx-12 mt-6 items-center" src="../images/sax.jpg">
        </div>
        <div class="flex flex-col mt-10 z-20">
          <img class="animate-translate-from-top w-72 mt-10 transform
          hover:-translate-y-4 duration-500 mx-2" src="../images/piano.jpg">
          <img class="animate-translate-from-left w-72 mt-8 transform
          hover:-translate-y-4 duration-500" src="../images/harp.jpg">
        </div>
        <div class="flex items-center">
            <img class="animate-translate-from-top transform
          hover:-translate-y-4 duration-500 h-72 mx-4" src="../images/guitar.jpg">
        </div> -->
      </div>
      <!-- <h1 class="flex flex-col text-2xl z-20 bg-white h-32 w-full opacity-60
            text-black animate-translate-from-left font-medium sticky top-0 inset-y-60
            justify-center blur text-center">
              {{ title }}!
      </h1> -->
      <div class="flex flex-col w-full">
        <masterclass-landing-page />
      </div>
      <div v-if="false">
        <div class="mt-20 mb-2 text-left text-2xl font-medium border-b-4 w-2/5 rounded
                    border-orange-academy-300 text-white">
          {{ $t('dashboard.teachers') }}
        </div>
        <div id="Teachers" >
            <teacher-list />
        </div>
        <router-link to="/teachers" class="pt-4 pb-10">
          <button class="border border-orange-academy-300 p-2 rounded-md uppercase
          text-orange-academy-300 hover:bg-orange-academy-300 hover:text-beige-academy-100
          hover:font-bold">
            {{ $t('masterclass.seeMore') }}
          </button>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import TeacherList from '@/components/teachers/TeacherList.vue';
import MasterclassLandingPage from '@/components/masterclasses/MasterclassLandingPage.vue';

export default {
  name: 'Home',

  components: {
    TeacherList,
    MasterclassLandingPage,
  },

  computed: {
    ...mapGetters({
      authenticated: 'auth/authenticated',
      user: 'auth/user',
    }),

    title() {
      return this.$t('home.title') + (this.authenticated ? `, ${this.user.name}` : '');
    },
  },

};
</script>

<style lang="scss" scoped>
  /* .parallax {

  min-height: 500px;

  background-attachment: fixed;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
} */

.blur {
    background: rgba(255, 255, 255, 0.75);
    backdrop-filter: blur( 3px );
    -webkit-backdrop-filter: blur( 1px );
    --tw-shadow: 0 4px 6px -1px rgb(179, 177, 177), 0 2px 4px -1px rgb(143, 133, 133);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000),
      var(--tw-shadow);
  }
.bgImageMobile {
  background-image: url('../images/piano.jpg');
  background-repeat: no-repeat;
}
</style>
